import { CrmOrganizationFeaturePage } from "..";

/** 学校组织维护页面。 */
export function CrmOrganizationPage() {
  return <CrmOrganizationFeaturePage />;
}
